import React, { useMemo } from 'react';

import { PercentageDiff } from 'components/Statistic/PercentageDiff';

type HottestCompanyJobsProps = {
  jobs: any[],
  loading: boolean,
};

export function HottestCompanyJobs({ jobs = [], loading }: HottestCompanyJobsProps) {
  const items = useMemo(() => {
    return jobs.map((job) => ({
      title: `${job.companyJobTitle} ${job.paymarketName}`, diff: Math.round(job.hotRate*100),
    }));
  }, [jobs]);

  return (
    <PercentageDiff items={items} loading={loading} />
  );
}
